import { Injectable, inject } from '@angular/core'

import { filter, tap } from 'rxjs'

import { AuthConfigService } from '@flowx/designer/modules/auth/auth.service'

import { AppEvents } from './app.events'

export class AppEffects {}

@Injectable({ providedIn: 'root' })
export class AppEffectsService {
  #authService = inject(AuthConfigService)
  constructor() {
    this.#authService.isAuthenticated$
      .pipe(
        filter(Boolean),
        tap(() => AppEvents.setUserProfile(this.#authService.userInfo))
      )
      .subscribe()
  }
}
